import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

interface ProductImageFallbackProps {
  className?: string;
  showMessage?: boolean;
}

export function ProductImageFallback({
  className,
  showMessage = true,
}: ProductImageFallbackProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'components.ProductImageFallback',
  });

  return (
    <div
      className={cn(
        'flex h-full w-full flex-col items-center justify-center bg-gray-100 p-4 text-gray-500',
        className,
      )}
    >
      <div className="mb-2 flex h-16 w-16 items-center justify-center rounded-lg bg-gray-200">
        <svg
          className="h-8 w-8 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
          />
        </svg>
      </div>

      {showMessage && (
        <span className="text-sm font-medium">{t('message')}</span>
      )}
    </div>
  );
}
